import React from 'react';

const About = () => {
  return (
    <div className='container'>
      <h3 className='mx-4 my-4 align-center'>About Me</h3>
        <div className='row'>
          <div className='col-sm'>
            <img src='/static/headshot.webp' alt='Headshot of fullstack engineer Kendal Enz' className='md-4' id='headshot'></img>
          </div>
          <div className='col-sm float-left' id='about-me-text'>
            <p>
              Hi, I’m Kendal Enz. I’m a content marketing and communications leader with a background in journalism, creative writing and technology. I specialize in turning complex ideas into clear, engaging stories and building content that connects with the people it’s meant to reach.</p>
            <p>
            <p>
              My work spans content strategy, thought leadership, editorial, campaigns and digital experiences, with a particular focus on subjects like AI, technology and law. My coding background also gives me a deeper understanding of technical concepts and helps me translate them into approachable, human-centered content.
            </p>
              In earlier years, I also wrote outdoor and adventure features for a local newspaper, work that still influences my love for immersive, narrative-driven storytelling.
            </p>
            <p>
              I hold an MA in Writing from Johns Hopkins University and a BA in Communications from Hood College. I’m based in Manhattan, NY, where I spend my free time running and working on my own creative projects.            
            </p>
          </div>
        </div>
    </div>
  );
};

export default About;